module.exports = __webpack_public_path__ + "img/25_17.064b523d.png";